import { useEffect } from "react";

import { useForm } from "react-hook-form";
import PhoneInputWithCountry from "react-phone-number-input/react-hook-form";
import "react-phone-number-input/style.css";

import { ErrorText } from "../error";
import { Label } from "../label";
import "./react-phone-number-input.css";

type Props = {
  name: string;
  label: string;
  value?: string;
  defaultValue?: string;
  placeholder?: string;
  register: any;
  header?: boolean;
  setValue: any;
  required?: boolean;
  error?: any;
  disabled?: boolean;
};

export default function PhoneNumber({
  name,
  label,
  placeholder,
  header = true,
  register,
  setValue,
  required,
  defaultValue,
  error,
  disabled,
}: Props) {
  useEffect(() => {
    if (defaultValue) {
      setValue(name, defaultValue, { shouldValidate: true });
    }
  }, [name, setValue, defaultValue]);

  const { ref, ...rest } = register;

  const { control } = useForm();

  const handleOnChange = (value: string) => {
    setValue(name, value);
  };

  return (
    <div>
      {header && <Label name={name} label={label} required={required} />}
      <div className="mt-2 font-input text-input">
        {!disabled ? (
          <PhoneInputWithCountry
            name={name}
            control={control}
            placeholder={placeholder}
            className="h-[38px] w-full rounded-md border border-gray-300 py-2 px-3 shadow-sm"
            defaultValue={defaultValue}
            {...rest}
            onChange={handleOnChange}
          />
        ) : (
          <textarea
            className={`block h-10 min-h-[38px] w-full resize-none rounded-md border border-gray-300 py-2 px-3 font-input text-input shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 ${
              disabled ? "bg-stone-100" : "bg-white"
            }`}
            defaultValue={defaultValue}
            name={name}
            id={name}
            placeholder={placeholder}
            disabled={disabled}
          />
        )}
        {error && <ErrorText error={error} />}
      </div>
    </div>
  );
}
